import React, { useEffect, useRef, useState } from 'react';
import { RadialGauge } from 'canvas-gauges';
import Panel from "../components/Panel";

// Source link
// https://canvas-gauges.com/documentation/examples/

/**
 * Converts Secondary Intercardinal direction codes to degrees
 * @param {string} direction - Direction code (N, NNE, NE, ENE, E, ESE, SE, SSE, S, SSW, SW, WSW, W, WNW, NW, NNW)
 * @returns {number} - Degree value (0-360)
 */
const convertDirectionToDegrees = (direction) => {
  const directionMap = {
    'N': 0,
    'NNE': 22.5,
    'NE': 45,
    'ENE': 67.5,
    'E': 90,
    'ESE': 112.5,
    'SE': 135,
    'SSE': 157.5,
    'S': 180,
    'SSW': 202.5,
    'SW': 225,
    'WSW': 247.5,
    'W': 270,
    'WNW': 292.5,
    'NW': 315,
    'NNW': 337.5
  };

  // Convert to uppercase and trim whitespace
  const normalizedDirection = direction?.toString().trim().toUpperCase();
  
  // Return the degree value or 0 if not found
  return directionMap[normalizedDirection] ?? 0;
};

const Anemometer = ({data}) => {
  const gaugeRef = useRef(null);
  const [gauge, createGauge] = useState({});

  useEffect(() => {
    const newGauge = new RadialGauge({
      renderTo: gaugeRef.current,
      minValue: 0,
      maxValue: 360,
      majorTicks: [
          "N",
          "NE",
          "E",
          "SE",
          "S",
          "SW",
          "W",
          "NW",
          "N"
      ],
      title: 'Wind',
      units: ``,
      colorUnits: 'yellow',
      fontUnitsSize: 30,
      colorTitle: 'white',
      minorTicks: 22,
      ticksAngle: 360,
      startAngle: 180,
      strokeTicks: false,
      highlights: false,
      colorPlate: "#33a",
      colorMajorTicks: "#f5f5f5",
      colorMinorTicks: "#ddd",
      colorNumbers: "#ccc",
      colorNeedle: "rgba(240, 128, 128, 1)",
      colorNeedleEnd: "rgba(255, 160, 122, .9)",
      valueBox: data?.showDirection,
      valueBox: false,
      valueDec: 0,
      valueTextShadow: false,
      colorCircleInner: "#fff",
      colorNeedleCircleOuter: "#ccc",
      needleCircleSize: 15,
      needleCircleOuter: false,
      animationRule: "linear",
      needleType: "line",
      needleStart: 50,
      needleEnd: 99,
      needleWidth: 3,
      borders: true,
      borderInnerWidth: 0,
      borderMiddleWidth: 0,
      borderOuterWidth: 4,
      colorBorderOuter: "#ccc",
      colorBorderOuterEnd: "#ccc",
      colorNeedleShadowDown: "#222",
      borderShadowWidth: 0,
      animationDuration: 1500,
      value: data?.direction
    });
    newGauge.draw();

    createGauge(newGauge)

    // return () => {
    //     gauge.destroy();
    //     // gauge2.destroy();
    // };
  }, []);

  // Convert direction code to degrees
  const directionInDegrees = convertDirectionToDegrees(data?.direction);
  
  gauge.value = directionInDegrees;
  gauge.valueBox = data?.showDirection;

  if (data?.showSpeed) gauge.units = `${data?.speed} kts`;

  return (
    <Panel >
      <canvas ref={gaugeRef} style={{padding: 10, width: '100%', height: '100%'}} />
    </Panel>
  );
};

export default Anemometer;
